// eslint-disable-next-line space-before-function-paren
export default function <T>(t: T | null | undefined): t is T {
  return t !== null && t !== undefined;
}
